import React from 'react';

export interface SkeletonProps {
  width?: string;
  height?: string;
  rounded?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  className?: string;
  count?: number;
  gap?: number;
}

const ROUNDED_STYLES: Record<NonNullable<SkeletonProps['rounded']>, string> = {
  sm: 'rounded',
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
  full: 'rounded-full',
};

const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  (
    {
      width = '100%',
      height = '1rem',
      rounded = 'lg',
      className = '',
      count = 1,
      gap = 2,
    },
    ref,
  ) => {
    const baseClasses = [
      'bg-surface-secondary animate-pulse',
      ROUNDED_STYLES[rounded],
    ].join(' ');

    const blockStyle: React.CSSProperties = { width, height };

    if (count > 1) {
      return (
        <div
          ref={ref}
          className={`flex flex-col ${className}`.trim()}
          style={{ gap: gap * 0.25 + 'rem' }}
        >
          {Array.from({ length: count }, (_, i) => (
            <div
              key={i}
              className={baseClasses}
              style={blockStyle}
              aria-hidden
            />
          ))}
        </div>
      );
    }

    return (
      <div
        ref={ref}
        className={`${baseClasses} ${className}`.trim()}
        style={blockStyle}
        aria-hidden
      />
    );
  },
);

Skeleton.displayName = 'Skeleton';

export default Skeleton;
